module.exports = __webpack_public_path__ + "static/media/teacher_view_quick_view_video.76bc636d.mov";